import staticObjectIcon from 'assets/icons/objectIcon.svg'
import shopMarkIcon from 'assets/icons/shopMark.svg'
import staticIcon from 'assets/icons/staticMark.svg'
import staticShopIcon from 'assets/icons/staticShop.svg'

// типы иконок для меток
export enum MarkIconType {
  geolocation,
  building,
  blueShop,
  redShop,
}

export const MarkIconTypeHref = {
  [MarkIconType.geolocation]: staticIcon,
  [MarkIconType.building]: staticObjectIcon,
  [MarkIconType.blueShop]: shopMarkIcon,
  [MarkIconType.redShop]: staticShopIcon,
}
